<template>
  <div class="container-fluid pt-0 mt-0">
    <AddGroupDevice
      v-if="addGroupDeviceModal"
      :show="addGroupDeviceModal"
      v-on:closeAddGroupDevice="
        addGroupDeviceModal = false;
        initialiseGroupDevices();
        $emit('getSingleDevice', 'device');
      "
    />
    <RemoveGroupDevice
      v-if="removeGroupDeviceModal"
      :show="removeGroupDeviceModal"
      :removedId="removedId"
      v-on:closeRemoveGroupDevice="
        removeGroupDeviceModal = false;
        $emit('getSingleDevice', 'device');
      "
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- <div class="row">
      <div class="col-5">
        <h4 class="p-b-20">{{ $t("devices") }}</h4>
      </div>
      <div class="col-7">
        <div class="d-flex align-items-center justify-content-end">
          <button
            v-if="profile.role !== 'staff'"
            @click="addGroupDeviceModal = true"
            class="btn btn-primary"
          >
            {{ $t("add_dev") }}
          </button>
        </div>
      </div>
    </div> -->

    <div class="card">
      <div class="card-body">
        <div class="mb-5">
          <TableSearch @handleSearch="handleSearch" />
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <div
                id="zero_config_wrapper"
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
              >
                <div class="row" style="height: 25rem; overflow: auto">
                  <div class="col-sm-12">
                    <table id="order-listing" class="table table-hover display">
                      <thead class="data-table-bg">
                        <tr>
                          <th>{{ $t("stat") }}</th>
                          <th>{{ $t("dev_tag") }}</th>
                          <th>IMEI</th>
                          <th>{{ $t("dev_name") }}</th>
                          <th>{{ $t("temp") }}</th>
                          <th>{{ $t("last_seen") }}</th>
                          <th>{{ $t("action") }}</th>
                        </tr>
                      </thead>
                      <tbody v-if="paginatedData.length > 0">
                        <tr
                          :key="index"
                          v-for="(device, index) in paginatedData"
                          class=""
                          :class="{
                            'data-table-bg': index % 2 !== 0,
                          }"
                        >
                          <td>
                            <div
                              style="display: flex; justify-content: left"
                              class="pt-2"
                            >
                              <div
                                v-if="!device.lastseen"
                                style="
                                  height: 0.8rem;
                                  width: 0.8rem;
                                  border-radius: 0.4rem;
                                "
                                class="bg-secondary"
                              ></div>
                              <div
                                v-else-if="device.status === 'stable'"
                                style="
                                  height: 0.8rem;
                                  width: 0.8rem;
                                  border-radius: 0.4rem;
                                "
                                class="bg-success"
                              ></div>
                              <div
                                v-else
                                style="
                                  height: 0.8rem;
                                  width: 0.8rem;
                                  border-radius: 0.4rem;
                                "
                                class="bg-danger"
                              ></div>
                            </div>
                          </td>
                          <td>{{ device.deviceTag }}</td>
                          <td>{{ device.imei }}</td>
                          <td>{{ device.deviceName }}</td>
                          <td>{{ device.temperature }}°C</td>
                          <td v-if="device.lastseen">
                            {{ device.lastseen }}
                          </td>
                          <td v-else>
                            {{ $t("no_read_yet") }}
                          </td>
                          <td>
                            <!-- <div style="cursor:pointer" class="btn-group">
                              <div
                                @click.prevent="
                                  showRemoveDevice(device.deviceTag)
                                "
                                class="fas fa-ellipsis-h"
                              ></div>
                              <div
                                class="dropdown-menu removedevice-dropdown"
                                v-bind:class="{
                                  show: RemoveDeviceShow(device.deviceTag),
                                }"
                                x-placement="bottom-start"
                              >
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-item mb-2"
                                  @click="viewdevice(device.deviceTag)"
                                  style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
                                >
                                  {{ $t("view_dev") }}
                                </a>
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-item"
                                  v-if="profile.role !== 'staff'"
                                  @click="removedevice(device.id)"
                                  style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
                                >
                                  {{ $t("rem_dev") }}
                                </a>
                              </div>
                            </div> -->

                            <div class="d-flex align-items-center col-gap-1">
                              <span
                                class="cursor-pointer"
                                @click="viewdevice(device.id)"
                              >
                                <IconEye />
                              </span>
                              <span
                                class="cursor-pointer"
                                v-if="profile.role !== 'staff'"
                                @click="removedevice(device.id)"
                              >
                                <IconDelete />
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody class="" v-else>
                        <tr align="center">
                          <td colspan="7">
                            <div class="col-md-6 col-lg-5 mx-auto">
                              <h3 class="mt-3">{{ $t("no_dev") }}</h3>
                              <p>
                                {{ $t("start_add") }}
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Pagination
                :pageCount="pageCount"
                :data="dataTable"
                :sizeperpage="sizeperpage"
                :pageNumber="pageNumber"
                :pages="pages"
                @goToLastPage="goToLastPage"
                @nextPage="nextPage"
                @handlePageChange="handlePageChange"
                @goToFirstPage="goToFirstPage"
                @prevPage="prevPage"
                @onchange="onchange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vClickOutside from "v-click-outside";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import AddGroupDevice from "../Modals/AddGroupDevice";
import RemoveGroupDevice from "../Modals/RemoveGroupDevice";
import tableMixin from "../../mixins/tableMixin";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import IconEye from "../../components/Iconsvg/IconEye.vue";

export default {
  name: "GroupDevices",
  data() {
    return {
      email: "",
      isLoading: true,
      fullPage: true,
      dataTable: [],
      Tag: "",
      removedId: "",
      addGroupDeviceModal: false,
      removeGroupDeviceModal: false,
      // singlegroup: {},
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    showModal: String,
  },
  mounted() {
    // this.singlegroup = { devices: this.singlegroupdevices?.devices };
    this.fetchSingleGroupDevices({ id: this.$route.params.id });
    this.initialiseGroupDevices();
    this.isLoading = false;
  },
  watch: {
    singlegroup: {
      handler: function () {
        this.initialiseGroupDevices();
      },
      deep: true,
    },
    showModal(val) {
      if (val === this.$route.name) {
        this.addGroupDeviceModal = true;
      }
      this.$emit("close_modal");
    },
  },
  computed: {
    ...mapGetters(["profile", "singlegroup"]),
  },
  components: {
    Loading,
    AddGroupDevice,
    RemoveGroupDevice,
    Pagination,
    TableSearch,
    IconDelete,
    IconEye,
  },
  mixins: [tableMixin],
  methods: {
    ...mapActions(["fetchSingleGroupDevices"]),
    initialiseGroupDevices() {
      this.dataTable = [];
      let lastseen;
      for (const element of this.singlegroup.devices) {
        if (element?.stat?.deviceTimeStamp) {
          let date = element?.stat?.deviceTimeStamp;
          lastseen = moment(date).format("ddd, MMM Do YYYY, hh:mm a");
        } else {
          lastseen = "";
        }
        this.dataTable.push({
          id: element.id,
          deviceTag: element.deviceTag,
          imei: element.imei,
          status: element.status,
          deviceName: element.settings.name,
          temperature: element?.stat?.temperature,
          lastseen: lastseen,
        });
      }
    },
    viewdevice(id) {
      this.Tag = "";
      let routeUrl = this.$router.resolve({
        path: `/devices/${id}/details`,
        query: { id: 96 },
      });
      window.open(routeUrl.href, "_blank");
    },
    removedevice(id) {
      this.Tag = "";
      this.removedId = id;
      this.removeGroupDeviceModal = true;
    },
    showRemoveDevice(deviceTag) {
      if (this.RemoveDeviceShow(deviceTag)) {
        this.Tag = "";
      } else {
        this.Tag = deviceTag;
      }
    },
    RemoveDeviceShow(deviceTag) {
      if (deviceTag == this.Tag) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}
th.active {
  color: #fff;
}
.removedevice-dropdown {
  left: -1000%;
}
</style>

<i18n>
{
	"en": {
		"add_dev": "Add Device",
		"dev_name": "Device Name",
		"dev_tag": "Device Tag",
		"imei": "IMEI",
		"last_seen": "Last Seen",
		"no_dev": "You have no devices yet",
		"no_read_yet": "No readings yet",
		"rem_dev": "Remove Device",
		"start_add": "Start adding devices you want to group together.",
		"stat": "Status",
		"temp": "Temperature",
		"view_dev": "View Device",
		"action": "Action"
	},
	"es": {
		"add_dev": "Añadir dispositivo",
		"dev_name": "Nombre del dispositivo",
		"dev_tag": "Etiqueta de dispositivo",
		"imei": "IMEI",
		"last_seen": "Ultima vez visto",
		"no_dev": "Aún no tienes dispositivos",
		"no_read_yet": "Aún no hay lecturas",
		"rem_dev": "Retire el dispositivo",
		"start_add": "Comience a agregar dispositivos que desee agrupar.",
		"stat": "Estado",
		"temp": "temperatura",
		"view_dev": "Ver dispositivo"
	},
	"fr": {
		"add_dev": "Ajouter un appareil",
		"dev_name": "Nom de l'appareil",
		"dev_tag": "Étiquette de l'appareil",
		"imei": "IMEI",
		"last_seen": "Vu pour la dernière fois",
		"no_dev": "Vous n'avez pas encore d'appareils",
		"no_read_yet": "Pas encore de lectures",
		"rem_dev": "Enlevez l'appareil",
		"start_add": "Commencez à ajouter des appareils que vous souhaitez regrouper.",
		"stat": "Statut",
		"temp": "Température",
		"view_dev": "Afficher l'appareil"
	},
	"sw": {
		"add_dev": "Ongeza Kifaa",
		"dev_name": "Jina la kifaa",
		"dev_tag": "Lebo ya Kifaa",
		"imei": "IMEI",
		"last_seen": "Mara ya mwisho kuonekana",
		"no_dev": "Bado huna vifaa",
		"no_read_yet": "Bado hakuna masomo",
		"rem_dev": "Ondoa Kifaa",
		"start_add": "Anza kuongeza vifaa unavyotaka kuvipanga pamoja.",
		"stat": "Hali",
		"temp": "Halijoto",
		"view_dev": "Tazama Kifaa"
	}
}
</i18n>
